<template>
  <page-outline>
    <template slot="pageContent">
      <div :class="['content navigation bg-light',{ expanded: !isSidebarOpen }]">
        <div>
          <div :class="{ active: !showReconcile }" @click="reconciliationObject != null ? showReconcile = false : ''">
            <i class="fa-regular fa-list"></i>
            Reconciliation Ledger
          </div>
          <div :class="{ active: showReconcile }" v-if="reconciliationObject != null" @click="showReconcile = true">
            <i class="fa-regular fa-code-branch"></i>
            Reconcile:
            <span>{{ reconciliationObject.VIBAN.slice(0,15) }}...</span>
            <i @click="closeReconciliation()" class="fa-regular fa-xmark"></i>
          </div>
        </div>
      </div>
      <div style="padding-top: 5rem;" :class="['content bg-light',{ expanded: !isSidebarOpen }]">
        <!-- LIST RECONCILIATION -->
        <div v-if="reconciliationObject == null || showReconcile == false">
          <b-container fluid>
            <!-- title -->
            <div class="content-title">
              <b-row>
                <h1>Reconciliation Ledger</h1>
              </b-row>
              <b-row>
                <span>Monitor and reconcile VIBANs with open transactions</span>
              </b-row>
            </div>

            <!-- data -->
            <b-row class="stats">
              <b-col @click="stat.status != null ? selectStatus(stat.status): ''" v-for="(stat, index) in stats" v-bind:key="index">
                <div>
                  <span :style="{color: stat.color}">{{ stat.number }}</span>
                  <span>{{ stat.title }}</span>
                </div>
              </b-col>
            </b-row>

            <!-- alert open items -->
            <div v-if=" this.totalOpenItems > 0" class="alert">
              <div>
                <i class="fa-regular fa-circle-exclamation"></i>
              </div>
              <div>
                <span>{{ this.totalOpenItems }} open item(s) across {{ this.totalPending }} VIBAN(s) need attention</span>
                <span>Click "Reconcile" to match payments and orders.</span>
              </div>
            </div>
          </b-container>

          <!-- flters -->
          <div class="filters">
            <b-row class="filters-items">
              <!-- Search -->
              <div class="filter-item">
                <span class="filter-item-title">Search VIBAN</span>
                <input type="text" class="filter-item-content" placeholder="Search by VIBAN or client number..." @input="event => (paginationObj.search = sanitize(event.target.value), submit())"  @keyup.enter="submit()"/>
              </div>
              <b-col>
                <!-- Status -->
                <div class="filter-item">
                  <span class="filter-item-title text-ellipsis">Status Filter</span>
                  <a id="status-picker-link"
                    class="filter-item-content d-flex justify-content-between py-2 px-3"
                    href="#">
                    <span class="fixed-span-size">
                      {{ this.paginationObj.pgstatus == null || this.paginationObj.pgstatus == "all" ? 'All Statuses' : statusList.filter(item => {
                        if(item.code == this.paginationObj.pgstatus){
                          return item
                        }
                    })[0].label}}
                    </span>
                    <i class="fa-light fa-chevron-down" size="17px" id="action-type-chevron"></i>
                  </a>
                   <b-popover target="status-picker-link" triggers="focus" placement="bottom" custom-class="popover">
                    <div>
                      <span v-for="(status, index) in statusList" :key="index" :class="['popover-option', {'popover-option-selected': status.code == 'all' ? paginationObj.pgstatus == null : status.code == paginationObj.pgstatus}]" @click="selectStatus(status.code)">
                        {{ status.label }}
                      </span>
                    </div>
                  </b-popover>
                </div>
                <!-- Country -->
                <div class="filter-item">
                  <span class="filter-item-title text-ellipsis">Country Filter</span>
                  <a id="country-picker-link"
                    class="filter-item-content d-flex justify-content-between py-2 px-3"
                    href="#">
                    <span class="fixed-span-size">
                      {{ this.paginationObj.country == null || this.paginationObj.country == "all" ? 'All Countries' : countryList.filter(item => {
                        if(item.code == this.paginationObj.country){
                          return item
                        }
                    })[0].label}}
                    </span>
                    <i class="fa-light fa-chevron-down" size="17px" id="action-type-chevron"></i>
                  </a>
                  <b-popover target="country-picker-link" triggers="focus" placement="bottom" custom-class="popover">
                    <div>
                      <span v-for="(country, index) in countryList" :key="index" :class="['popover-option', {'popover-option-selected':  country.code == paginationObj.country}]" @click="selectCountry(country.code)">
                        {{ country.label }} {{ country.code != null ? '(' + country.code + ')' : '' }}
                      </span>
                    </div>
                  </b-popover>
                </div>
              </b-col>
              <!-- Pagination -->
              <div class="filter-item">
                <span class="filter-item-title text-ellipsis">Per Page</span>
                <a id="pagination-picker-link"
                  class="filter-item-content d-flex justify-content-between py-2 px-3"
                  href="#">
                  <span class="fixed-span-size">{{ this.paginationObj.maxResults }}</span>
                  <i class="fa-light fa-chevron-down" size="17px" id="page-chevron"></i>
                </a>
                <b-popover target="pagination-picker-link" triggers="focus" placement="bottom" custom-class="popover">
                  <div>
                    <span v-for="(resultsPerPage, index) in [10,20,30,40,50]" :key="index" :class="['popover-option', {'popover-option-selected':  resultsPerPage == paginationObj.maxResults}]" @click="selectPagination(resultsPerPage)">
                      {{ resultsPerPage }}
                    </span>
                  </div>
                </b-popover>
              </div>
            </b-row>
            <hr>
            <b-row class="filter-btns">
              <b-col>
                <span v-if="totalResultsFiltered > 0">Showing {{ paginationObj.firstIndex }} - {{totalResultsFiltered < paginationObj.maxResults ? totalResultsFiltered : currentPage * paginationObj.maxResults}} of {{ totalResultsFiltered }}
                  </span>
                  <span class="selected" v-if="selectedItems.length > 0">{{ selectedItems.length }} selected</span>

                  <button @click="clearSelection()" class="clear" v-if="selectedItems.length > 0"><i class="fa-classic fa-xmark"></i>Clear</button>
              </b-col>

              <div style="display:flex; align-items:center;  gap: 1rem;">

                <button @click="exportSelected()" v-if="selectedItems.length > 0"  class="btn-outline btn-tertiary"><i class="fa-classic fa-arrow-down-to-line"></i>Export Selected ({{ selectedItems.length }})</button>

                <button @click="exportFiltered()" class="btn-outline button-primary"><i class="fa-classic fa-arrow-down-to-line"></i>Export Filtered</button>

                <button @click="exportAll()" class="btn-outline button-primary"><i class="fa-classic fa-arrow-down-to-line"></i>Export All</button>

                <button @click="refresh()" class="btn-outline btn-dark">
                  <i :class="['fa-classic', 'fa-arrows-rotate', { 'rotate': isLoading }]"></i>
                  Refresh
                </button>
              </div>
            </b-row>
          </div>

          <!-- VIBANs list -->
          <div v-if="items != null" class="card">
            <div class="p-6">
              <h2>VIBAN Reconciliation Status</h2>
              <span>{{ totalVibanAssigned }} VIBAN{{ totalVibanAssigned> 1 ? 's':'' }}</span>
            </div>
            <hr>
            <div v-if="totalResultsFiltered > 0" style="overflow-x:auto">
              <b-table responsive
                style="margin-bottom:0;"
                :items="items"
                :fields="fields"
                primary-key="id"
              >
              
                <template #head(checkbox)>
                  <label class="custom-checkbox">
                    <input type="checkbox" 
                      id="all" 
                      name="checkAll"
                      @change="selectAll($event)" />
                    <span class="checkmark"></span>
                  </label>
                </template>

                <template #cell(checkbox)="data">
                  <label class="custom-checkbox">
                    <input type="checkbox"
                          :value="data.item"
                          @change="toggleSelection($event, data.item)" />
                    <span class="checkmark"></span>
                  </label>
                </template>

                <template #cell(clientnumber)="data">
                  <span v-if="data.item.Reference1 != ''">{{ data.item.Reference1 }}</span>
                  <span v-else style="font-weight: normal;">—</span>
                </template>

                <template #cell(country)="data">
                  <span class="btn-empty">{{ data.item.VIBAN.substring(0, 2) }}</span> 
                </template>

                <template #cell(amount)="data">
                  <span :style="{'color':data.item.Amount > 0 ? '#00a63e': data.item.Amount < 0 ? '#f54a00':'#6a7282' }" >€{{Number(data.item.Amount).toFixed(2) }}</span>
                </template>

                <template #cell(openAmount)="data">
                  <span :style="{'color':data.item.AmountCredit + data.item.Amount < 0 ? '#00a63e': data.item.AmountCredit + data.item.Amount > 0 ? '#f54a00':'#6a7282' }" >€{{Number(data.item.AmountCredit + data.item.Amount).toFixed(2) }}</span>
                </template>

                <template #cell(openItems)="data">
                  <div style="display: grid;" v-if="Number(data.item.NbFactures) + Number(data.item.NbTransactions) > 0">
                    <span style="font-size: 1.2rem;">{{ Number(data.item.NbFactures ) + Number(data.item.NbTransactions) }}</span>
                    <span style="font-weight: normal; color: #6a7282; font-size: 0.9rem;">{{data.item.NbTransactions}}P / {{data.item.NbFactures}}O</span>
                  </div>
                  <span v-else style="font-size: 1.2rem;">0</span>
                </template>

                <template #cell(actions)="data">
                  <div style="gap: 0.5rem; justify-content: center;" class="d-flex">
                    <button v-if="data.item.Status != 2" :id="`view-rec-detail-btn-${data.index}`" @click="getReconciliationDetail(data.item)" class="btn-outline-light btn-blue"><i class="fa-regular fa-code-branch"></i></button>
                    <b-popover
                      :target="`view-rec-detail-btn-${data.index}`"
                      triggers="hover"
                      placement="top"
                      custom-class="popover-btn"
                    >
                      View reconciliation detail
                    </b-popover>
  
                    <button :id="`view-transaction-btn-${data.index}`" @click="navigate('/transactionledger/'+data.item.VIBAN)" class="btn-outline-light">
                      <i class="fa-regular fa-eye"></i>
                    </button>
                    <b-popover
                      :target="`view-transaction-btn-${data.index}`"
                      triggers="hover"
                      placement="top"
                      custom-class="popover-btn"
                    >
                      View transaction
                    </b-popover>
                  </div>
                </template>

                <template #cell(status)="data">
                  <button style="cursor: default; gap: 0.5rem; display: flex; align-items: center;" v-if="Number(data.item.NbFactures) + Number(data.item.NbTransactions) > 0" :style="{color:'#a16207','background-color':'#fefce8','border-color':'#fef08a'}" class="btn-tertiary-full"><i class="fa-light fa-clock"></i>Pending ({{ Number(data.item.NbFactures) + Number(data.item.NbTransactions)}})</button>
                  
                  <button style="cursor: default; gap: 0.5rem; display: flex; align-items: center;" v-else-if="Number(data.item.NbFactures == '' ? 0:data.item.NbFactures) + Number(data.item.NbTransactions == '' ? 0:data.item.NbTransactions) == 0 && data.item.AmountCredit == 0" class="btn-tertiary-full" :style="{color:'#008236','background-color':'#f0fdf4','border-color':'#b9f8cf'}"><i class="fa-light fa-circle-check"></i>Clean</button>
                  
                  <button style="cursor: default;  gap: 0.5rem; display: flex; align-items: center;" v-else class="btn-tertiary-full" :style="{color:'#c10007','background-color':'#fef2f2','border-color':'#c1000773'}"><i class="fa-light fa-triangle-exclamation"></i>Needs Action</button>
                </template>

                <template #cell(lastActivity)="data">
                  <div v-if="data.item.LastUpdate != ''">{{new Date(Date.parse(data.item.LastUpdate )).toLocaleDateString("fr")}}</div>
                  <span style="color: #6a7282; font-size: 0.9rem;" v-if="data.item.LastUpdate != ''">{{new Date(Date.parse(data.item.LastUpdate )).toLocaleTimeString("it-IT")}}</span>
                  <span v-else >—</span>
                </template>

              </b-table>
              <hr>
            </div>
            <b-row v-if="totalResultsFiltered > 0" class="pagination">
              <button @click="currentPage > 1 && previous()" :class="['btn-outline-light btn', {inactive: currentPage == 1}]">Previous</button>
              <span>Page {{ currentPage }} of {{ totalPages }}</span>
              <button @click="currentPage < totalPages && next()" :class="['btn-outline-light btn', {inactive: currentPage == totalPages}]">Next</button>
            </b-row>
            <div v-else style="margin: 1rem; color: #969696;">
              <span>No results found</span>
            </div>
          </div>
          <div class="card empty" v-else>
            <b-spinner label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- DETAIL RECONCILE -->
        <detail-reconciliation v-else :reconciliationObject="reconciliationObject" @close-reconciliation="closeReconciliation"></detail-reconciliation>
      </div>
    </template>
  </page-outline>
</template>

<script>
import DetailReconciliationLedgerPage from './DetailReconciliationLedgerPage.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import moment from 'moment'
import { loadPage } from '@/helpers/routing'

export default {
  name: 'ReconciliationLedger',
  components: {
    'page-outline': PageOutline,
    'detail-reconciliation': DetailReconciliationLedgerPage
  },
  data(){
    return {
      items: null,
      fields: [
        { key: 'checkbox', thClass: 'text-center align-middle border-bottom', tdClass: 'text-center align-middle'},
        { key: 'VIBAN', label: 'VIBAN', thClass: 'text-left align-middle border-bottom', tdClass: 'align-middle text-left'},
        { key: 'clientNumber', label: 'Client Number', thClass: 'text-left align-middle border-bottom', tdClass: 'align-middle text-left font-weight-bold'},
        { key: 'country', label: 'Country', thClass: 'text-left align-middle border-bottom', tdClass: 'align-middle text-left font-weight-bold'},
        { key: 'openItems', label: 'Open Items', thClass: 'text-center align-middle border-bottom text-nowrap', tdClass: 'align-middle text-center font-weight-bold text-nowrap'},
        { key: 'openAmount', label: 'Open Amount', thClass: 'text-right align-middle text-nowrap border-bottom', tdClass: 'align-middle text-right font-weight-bold'},
        { key: 'amount', label: 'Total Volume', thClass: 'text-right align-middle text-nowrap border-bottom', tdClass: 'align-middle text-right font-weight-bold'},
        { key: 'lastActivity', label: 'Last Activity', thClass: 'text-left align-middle text-nowrap border-bottom', tdClass: 'align-middle text-left'},
        { key: 'status', label: 'Status', thClass: 'text-left align-middle border-bottom', tdClass: 'align-middle text-left text-nowrap'},
        { key: 'actions', label: 'Actions', thClass: 'text-center align-middle border-bottom', tdClass: 'text-center align-middle' }
      ],
      countryList: [
        {
          label: "All Countries",
          code: null
        },
        {
          label: "France",
          code: "FR"
        },
        {
          label: "Germany",
          code: "DE"
        },
        {
          label: "Spain",
          code: "ES"
        },
        {
          label: "UK",
          code: "GB"
        },
        {
          label: "Belgium",
          code: "BE"
        },
        {
          label: "Italy",
          code: "IT"
        }
      ],
      statusList: [
        {
          label: "All Statuses",
          code: "all"
        },
        {
          label: "Needs Action",
          code: 'need'
        },
        {
          label: "Pending",
          code: 'pending'
        },
        {
          label: "Clean",
          code: 'clear'
        }
      ],
      stats: [
        {
          "title":"Total VIBANs",
          "number": 0,
          "color": "#2b7fff",
          "status": "all"
        },
        {
          "title":"Needs Action",
          "number": 0,
          "color": "#e7000b",
          "status": 'need'
        },
        {
          "title":"Pending",
          "number": 0,
          "color": "#d08700",
          "status": 'pending'
        },

        {
          "title":"Clean",
          "number": 0,
          "color": "#009966",
          "status": 'clear'
        },
        {
          "title":"Match Rate",
          "number": '0%',
          "color": "#9810fa"
        }
      ],
      paginationObj: {
        firstIndex: 1,
        maxResults : 10,
        sortOrder: null,
        search : null,
        status: null,
        pgstatus: null,
        country : null,
      },
      search: {
        payment: '',
        refund: '',
        order: '',
        paymentResults: []
      },
      refundObj: {
        IBAN: null,
        amount: null,
        reference: null,
        reason: null
      },
      selectedItems: [],
      totalResultsFiltered: null,
      totalVibanAssigned: null,
      totalOpenItems: 0,
      totalPending: 0,
      currentPage: 1,
      totalPages: 0,
      reconciliationObject: null,
      isSidebarOpen: true,
      isLoading: false,
      showReconcile: false,
      selectRefund: null
    }
  },
  created(){
    this.paginationObj.status = 1;
    this.$engine.services.payments.getGroups(this.paginationObj)
    .then(resp => {
      const data = resp.data
      this.items = data.references
      
      this.totalOpenItems = data.nbTotalOpenItems
      this.totalPending = data.nbTotalPending

      this.totalResultsFiltered = data.nbTotalResultsFiltered
      this.totalVibanAssigned = data.nbVibanAssigned

      this.stats[0].number = data.nbVibanAssigned
      this.stats[1].number = data.nbTotalNeed
      this.stats[2].number = data.nbTotalPending
      let clear = data.nbVibanAssigned -  data.nbTotalNeed - data.nbTotalPending
      this.stats[3].number = clear
      this.stats[4].number = data.nbVibanAssigned == 0 ? '0%': Math.round(( clear * 100) / data.nbVibanAssigned) + '%'

      this.totalPages = Math.ceil(data.nbTotalResultsFiltered/this.paginationObj.maxResults)
      this.currentPage = (this.paginationObj.firstIndex -1) / this.paginationObj.maxResults + 1
    })
    .catch(err => {
      console.log(err)
    })
  },
  methods: {
    previous(){
      this.paginationObj.firstIndex = this.paginationObj.firstIndex - this.paginationObj.maxResults
      this.currentPage--
      this.$engine.services.payments.getGroups(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.references;
      })
      .catch(err => {
        console.log(err)
      })
    },
    next(){
      this.paginationObj.firstIndex = this.paginationObj.firstIndex + this.paginationObj.maxResults
      this.currentPage++
      this.$engine.services.payments.getGroups(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.references;
      })
      .catch(err => {
        console.log(err)
      })
    },
    submit(){
      this.paginationObj.firstIndex = 1;
      this.currentPage = 1;

      this.$engine.services.payments.getGroups(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.references

        this.totalOpenItems = data.nbTotalOpenItems
        this.totalPending = data.nbTotalPending

        this.totalResultsFiltered = data.nbTotalResultsFiltered
        this.totalVibanAssigned = data.nbVibanAssigned

        this.stats[0].number = data.nbVibanAssigned
        this.stats[1].number = data.nbTotalNeed
        this.stats[2].number = data.nbTotalPending
        let clear = data.nbVibanAssigned -  data.nbTotalNeed - data.nbTotalPending
        this.stats[3].number = clear
        this.stats[4].number = data.nbVibanAssigned == 0 ? '0%': Math.round(( clear * 100) / data.nbVibanAssigned) + '%'

        this.totalPages = Math.ceil(data.nbTotalResultsFiltered/this.paginationObj.maxResults)
        this.currentPage = (this.paginationObj.firstIndex -1) / this.paginationObj.maxResults + 1
      })
      .catch(err => {
        console.log(err)
      })
    },
    toggleOrder(){
      this.paginationObj.sortOrder = this.paginationObj.sortOrder == 'asc' ? 'desc' : 'asc';

      this.$engine.services.payments.getGroups(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.references
        this.totalResultsFiltered = data.nbTotalResultsFiltered
        this.totalPages = Math.ceil(data.nbTotalResultsFiltered/this.paginationObj.maxResults)
      })
      .catch(err => {
        console.log(err)
      })

    },
    toggleSelection(event, value) {
      const checked = event.target.checked;

      if (checked) {
        if (!this.selectedItems.some(item => item.VIBAN == value.VIBAN)) {
          this.selectedItems.push(value)
        }
      } else {
        const checkbox = document.querySelectorAll('input[type="checkbox"]')[0]
        if(checkbox.checked){
          checkbox.checked = false
        }
        this.selectedItems = this.selectedItems.filter(item => item.VIBAN !== value.VIBAN);
      }
    },
    selectAll(event){
      const checked = event.target.checked;
      const checkboxes = document.querySelectorAll('input[type="checkbox"]')
      if (checked) {
        checkboxes.forEach(item => item.checked = true)
        this.selectedItems = [...this.items];
      } else {
        this.selectedItems = []
        checkboxes.forEach(item => item.checked = false)
      }
    },
    clearSelection() {
      this.selectedItems = []
      const checkboxes = document.querySelectorAll('input[type="checkbox"]')
      checkboxes.forEach(item => item.checked = false)
    },
    selectStatus(status){
      this.paginationObj.pgstatus = status == "all" ? null : status
      this.paginationObj.firstIndex = 1

      this.$engine.services.payments.getGroups(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.references
        this.totalResultsFiltered = data.nbTotalResultsFiltered
        this.totalPages = Math.ceil(data.nbTotalResultsFiltered/this.paginationObj.maxResults)
        this.currentPage = (this.paginationObj.firstIndex -1) / this.paginationObj.maxResults + 1
        document.activeElement?.blur()
      })
      .catch(err => {
        console.log(err)
      })
    },
    selectCountry(code){
      this.paginationObj.country = code

      this.$engine.services.payments.getGroups(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.references
        this.totalResultsFiltered = data.nbTotalResultsFiltered
        this.totalPages = Math.ceil(data.nbTotalResultsFiltered/this.paginationObj.maxResults)
        document.activeElement?.blur()
      })
      .catch(err => {
        console.log(err)
      })
    },
    selectPagination(resultsPerPage){
      this.paginationObj.maxResults = resultsPerPage
      this.paginationObj.firstIndex = 1

      this.$engine.services.payments.getGroups(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.references
        this.totalResultsFiltered = data.nbTotalResultsFiltered
        this.totalPages = Math.ceil(data.nbTotalResultsFiltered/this.paginationObj.maxResults)
        this.currentPage = (this.paginationObj.firstIndex -1) / this.paginationObj.maxResults + 1
        document.activeElement?.blur()
      })
      .catch(err => {
        console.log(err)
      })
    },
    exportCSV(filters){
      this.$engine.services.payments.getGroups(filters)
      .then(resp => {
        const vibanData = resp
        let firstLine = 'Virtual IBAN' + ';' +
          'Client Number' + ';' +
          'Country' + ';' +
          'Open Items' + ';' +
          'Open Amount' + ';' +
          'Total Volume' + ';' +
          'Last Activity' + ';' +
          'Status' + '\r\n'

        let line = ''

        vibanData.data.references.forEach(item => {
          line += item.VIBAN + ';' + item.Reference1 + ';' +
          item.VIBAN.slice(0,2) + ';' + Number(item.NbFactures ) + Number(item.NbTransactions) + ';' + Number(item.AmountCredit + item.Amount).toFixed(2) + ';' + item.Amount.toFixed(2) + ';'  + (item.LastUpdate != "" ? new Date(Date.parse(item.LastUpdate )).toLocaleDateString("fr") + ' ' + new Date(Date.parse(item.LastUpdate )).toLocaleTimeString("it-IT") : ' ' )  + ';' + (Number(item.NbFactures) + Number(item.NbTransactions) > 0 ? 'Pending' : Number(item.NbFactures == '' ? 0 : item.NbFactures) + Number(item.NbTransactions == '' ? 0 : item.NbTransactions) == 0 && item.AmountCredit == 0 ? 'Clean' : 'Needs Action' ) + '\r\n'
        })

        let data = firstLine + line
        let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
        let downloadLink = document.createElement('a')
        let today = moment()
        let fileName = 'reconciliations_' + today.unix() + '.csv'

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      })
      .catch(err => {
        console.log(err)
      })
    },
    exportAll () {
      this.exportCSV({})
    },
    exportFiltered () {
      this.exportCSV({
        firstIndex: 1,
        sortOrder: this.paginationObj.sortOrder,
        search : this.paginationObj.search,
        status: this.paginationObj.status,
        pgstatus: this.paginationObj.pgstatus,
        country : this.paginationObj.country,
      })
    },
    exportSelected(){
      const selection = [...this.selectedItems];

      let firstLine = 'Virtual IBAN' + ';' +
          'Client Number' + ';' +
          'Country' + ';' +
          'Open Items' + ';' +
          'Open Amount' + ';' +
          'Total Volume' + ';' +
          'Last Activity' + ';' +
          'Status' + '\r\n'

      let line = ''

      selection.forEach(item => {
        line += item.VIBAN + ';' + item.Reference1 + ';' +
          item.VIBAN.slice(0,2) + ';' + Number(item.NbFactures ) + Number(item.NbTransactions) + ';' + Number(item.AmountCredit + item.Amount).toFixed(2) + ';' + item.Amount.toFixed(2) + ';'  + (item.LastUpdate != "" ? new Date(Date.parse(item.LastUpdate )).toLocaleDateString("fr") + ' ' + new Date(Date.parse(item.LastUpdate )).toLocaleTimeString("it-IT") : ' ' )  + ';' + (Number(item.NbFactures) + Number(item.NbTransactions) > 0 ? 'Pending' : Number(item.NbFactures == '' ? 0 : item.NbFactures) + Number(item.NbTransactions == '' ? 0 : item.NbTransactions) == 0 && item.AmountCredit == 0 ? 'Clean' : 'Needs Action' ) + '\r\n'
      })

      let data = firstLine + line
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      let today = moment()
      let fileName = 'vibans_' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    // openModal(item) {
    //   this.selectRefund = item
    //   this.isModalOpen = true
    // },
    // closeModal(){
    //   this.selectRefund = null
    //   this.isModalOpen = false
    // },
    refresh(){
      if (this.isLoading) return;
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        this.paginationObj = {
          firstIndex: 1,
          maxResults : 10,
          sortOrder: null,
          search : null,
          status: null,
          country : null,
        };
        this.submit()
      }, 800);
    },
    closeReconciliation(){
      this.reconciliationObject = null
      this.showReconcile = false
    },
    togglePage(){
      this.showReconcile = !this.showReconcile
    },
    getReconciliationDetail(item){
      this.reconciliationObject = item
      this.showReconcile = true
    },
    navigate(url){
      console.log(url)
      loadPage(this, {url: url})
    },
    createRefund(){
      if(this.refundObj.amount != null && this.refundObj.IBAN != null && this.refundObj.amount > 0 && this.refundObj.IBAN.length > 0){
        let invoice = {
          "InvoiceIdentifier": this.refundObj.reference,
          "PaymentDate": moment(),
          "Amount": this.refundObj.amount,
          "Type": 'Refund',
          "Description": this.refundObj.reason,
          "Reference1": this.selectRefund.Reference1
        }
        console.log(this.refundObj, this.selectRefund, invoice)
        this.$engine.services.payments.createInvoice(invoice)
        .then(resp => {
           if(resp.status == 201) this.closeModal()
        })
      }
    },
    sanitize(value) {
      if (typeof value !== 'string') return ''

      return value
        .trim()
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .replace(/\r?\n|\r/g, '')
    }
  }
}
</script>
<style scoped>

  .disabled{
  opacity: 0.5;
  pointer-events: none;
  white-space: nowrap;
}

.information-container{
  display: flex;
  align-items: baseline;
  gap: 1rem;
  padding: calc(.25rem * 4);
  background-color: #eff6ff;
  border: 1px solid #bfdbfe;
  color: #717182;
  border-radius: .625rem;
  margin: 1rem 0rem;
}

.information-container>i {
  font-weight: bold;
}

.information-container>div{
  display: grid;
}

.information-container>div>span>span{
  font-weight: bold;
}

.modal-container{
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 5000;
  overflow: hidden;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content .filter-item {
  margin: 1rem 0rem;
}

.modal-content>h1{
  font-weight: bold;
  font-size: 1.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000;
}

.modal-content>h1>i{
  cursor: pointer;
}

.modal-content>input, textarea{
  margin: 0.5rem 0rem;
}

.modal-content>span:first-of-type{
  color: #717182;
  margin-bottom: 1rem;
}

.modal-content>span:last-of-type{
  color: #000;
  font-weight: bold;
}

.filter-item-title{
  margin: 1rem 0rem 0rem 0rem;
}

small{
  color: #6a7282;
}

.filter-btns{
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding-right:1rem;
}

.filter-btns .btn-outline {
  /* font-weight: bold !important; */
}

.filter-btns>div:first-child{
  display: flex;
  gap: 1rem;
  align-items: center;
}

h1{
  padding: 0%;
}

h4{
  font-weight: bold;
  color: #000 !important;
  padding: 0%;
}

.alert{
  display: flex;
  gap: 1rem;
  margin: 1rem -1rem;
  padding: 1rem 0rem;
  align-items: center;
  max-height: 6rem;
  background-color: #fefce8;
  border: 1px solid #fef08a;
  border-radius: calc(1rem - 2px);
  padding: 1.5rem 1rem;
  color: #a16207;
}

.alert>div:first-child>i{
  font-size: 1.5rem;
  color: #d08700;
}

.alert>div:last-child>span:first-child{
  font-weight: bold;
}

.alert>div:last-child{
  display: grid;
}

.navigation{
  min-height: 3rem;
  position: fixed;
  width: 100%;
  z-index: 1;
  border-bottom: 1px solid #0000001a;
  box-shadow: 0 1px 3px 0 #0000001a, 0 1px 2px -1px #0000001a;
}

.navigation>div{
  display: flex;
}

.navigation>div>div{
  padding: 1rem;
  width: 100%;
  gap: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3rem;
  font-weight: bold;
  cursor: pointer;
}

.navigation>div>div>span{
  background-color: #eff6ff;
  font-size: 0.75rem;
  font-weight: lighter;
  padding: 0.3rem;
  border-radius: calc(0.625rem - 2px);
  width: 8rem;
  white-space: nowrap;
}

.navigation>div>div>i{
  font-size: 1rem;
}

.navigation>div>div:last-child>i:last-child{
  cursor: pointer;
  padding: 0.4rem;
}

.navigation>div>div:last-child>i:last-child:hover{
  background-color: rgb(207, 207, 207);
  border-radius: .25rem;
}

.active{
  background-color: #fff;
  border: 1px solid #155dfc;
  border-bottom-width: 2px;
  border-radius: calc(.625rem + 4px);
  border-top-left-radius: calc(.625rem - 2px);
  border-top-right-radius: calc(.625rem - 2px);
  color: #155dfc;
}

.stats>div{
  display: flex;
}

.rotate {
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.selected {
  padding: 0.5rem;
  font-weight: bold;
  border-radius: calc(0.625rem - 2px);
  background-color: #dbeafe;
  color: #1d4ed8;
}

.clear{
  cursor: pointer;
  padding: 0.5rem;
  font-weight: bold;
  border-radius: calc(0.625rem - 2px);
  border: none;
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: transparent;
}

.clear:hover{
  background-color: #e9ebef;
}

.fa-circle-question, .fa-chevron-down, .fa-chevron-up{
  margin: 0rem 0.5rem;
  color: #99a1af;
}

.fa-circle-question:hover{
  color: #4a5565;
}

.pagination{
  display: flex;
  align-items: center;
  color: #000000a6;
  padding: 1rem 2rem;
}

table{
  width: 100%;
  padding: 0;
}

td:nth-child(2), td:nth-child(3){
  font-size: 0.8rem;
}

td:last-child>.btn-outline-light{
  height: 2.75rem;
  height: 3rem;
}

tr:not(:first-child){
  border-top: 1px solid #0000001a;
}

td, th {
  font-weight: initial;
  padding: 1rem 1rem 1rem 2rem;
  white-space: nowrap;
}

th:nth-of-type(7){
  text-align: end;
}

td:nth-of-type(5)>span:first-child{
  font-weight: bold;
}

td:nth-of-type(7), td:nth-of-type(6){
  font-weight: bold;
  font-size: 1.25rem;
  text-align: end;
  color: #6a7282;
}

th:nth-of-type(8){
  text-align: center;
}

td:last-of-type{
  display: flex;
  gap: 0.2em;
  justify-content: end;
  align-items: center;
}

td:first-child, th:first-child{
  padding: 1rem;
}

thead {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1019607843);
}

tr:hover{
  background-color: #f8f9fa;
}

.btn-blue{
  background-color: #155dfc !important;
  color: #fff !important;
}

.btn-blue:hover{
  background-color: #1d4ed8;
}

.refund-btn{
  background-color: #f54a00;
  color: #fff !important;
}

.refund-btn:hover{
  background-color: #c2410c;
}

.inactive{
  color: #0a0a0a;
  opacity: .5;;
  pointer-events: none;
  outline-style: none;
}

.content-title{
  margin: 1.5rem 0rem;
}


.content-title>div>span{
  color: #000000a6;
  font-size: 1.1rem;
}

.filters{
  margin: 2rem 0rem;
}

.filters-container{
  width: 100%;
  margin: 2rem 0rem 0rem 0rem;
  border: 1px solid #0000001a;
  border-radius: calc(1rem - 2px);
  background-color: #fff;
  padding: 2rem;
}

.filters-items{
  display: grid;
  grid-template-columns: 7fr 4fr 1fr;
  padding: 0rem 1rem;
}

.filters-items>div:nth-child(2){
  display: flex;
  gap: 1rem;
}

.stats{
  display: flex;
  gap: 1rem;
  padding: 1rem 0rem;
}

.stats>div{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 8rem;
  background-color: #fff;
  border: 1px solid #0000001a;
  border-radius: calc(1rem - 2px);
  padding: 0rem 1rem;
}

.stats>div:hover:not(:last-child){
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  cursor: pointer;
}

.stats>div>div{
  display: grid;
  row-gap: 1.5rem;
  color: #000000a6;
}

.stats>div>div>span:last-of-type{
font-size: 1rem;
}

.stats>div>div>span{
  font-size: 2rem;
  display: flex;
  justify-content: center;
}
</style>